(function () {
  function initBundleDealCard(root) {
    var toggleButton = root.querySelector('[data-bundle-toggle]');
    var bodyEl = root.querySelector('[data-bundle-body]');
    if (toggleButton && bodyEl) {
      toggleButton.addEventListener('click', function (event) {
        event.preventDefault();
        var isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        toggleButton.setAttribute('aria-expanded', String(!isExpanded));
        toggleButton.textContent = isExpanded ? '+' : '\u2212';
        bodyEl.hidden = isExpanded;
      });
    }
    var tierButtons = root.querySelectorAll('.bundle-deal-tier');
    var ctaButton = root.querySelector('[data-add-bundle]');
    if (!ctaButton || tierButtons.length === 0) return;
    var isProductContext = root.getAttribute('data-context') === 'product';
    var bundleHandle = root.getAttribute('data-bundle-handle') || '';
    var currentVariantId = root.getAttribute('data-current-variant-id');
    var modal = root.querySelector('[data-modal]');
    var modalOverlay = root.querySelector('[data-modal-overlay]');
    var modalClose = root.querySelector('[data-modal-close]');
    var pickerGrid = root.querySelector('[data-picker-grid]');
    var pickerCount = root.querySelector('[data-picker-count]');
    var pickerNeeded = root.querySelector('[data-picker-needed]');
    var pickerFilters = root.querySelector('[data-picker-filters]');
    var pickerSearch = root.querySelector('[data-picker-search]');
    var pickerEmpty = root.querySelector('[data-picker-empty]');
    var pickerLoading = root.querySelector('[data-picker-loading]');
    var selectionStrip = root.querySelector('[data-selection-strip]');
    var errorEl = root.querySelector('[data-error]');
    var singleTier = root.querySelector('.bundle-deal-tier--single');
    var singleLabel = root.querySelector('[data-single-label]');
    var singlePriceEl = root.querySelector('[data-single-price]');
    var singleStepper = root.querySelector('[data-single-stepper]');
    var singleMinus = root.querySelector('[data-single-minus]');
    var singlePlus = root.querySelector('[data-single-plus]');
    var singleCountEl = root.querySelector('[data-single-count]');
    var singleBasePrice = singleTier ? parseFloat(singleTier.getAttribute('data-base-price')) : 0;
    var singleQty = 1;
    var addSingleBtn = root.querySelector('[data-add-single]');
    var errorSingleEl = root.querySelector('[data-error-single]');
    var activeCat = modal ? (modal.getAttribute('data-current-cat') || '') : '';
    var basePriceCents = modal ? parseInt(modal.getAttribute('data-base-price'), 10) : 0;
    var selectedCounts = {};
    var selectedMeta = {};
    var selectedTotal = 0;
    var currentTier = { qty: 1, price: null };
    var searchTerm = '';
    var catCache = {};
    var catLoaded = {};
    var probedTabs = false;
    var catTitleMap = {};
    var userPickedTab = false;
    var multiBucket = modal ? modal.getAttribute('data-multi-bucket') === '1' : false;
    var bucketMap = {};
    if (multiBucket && modal) {
      try {
        var raw = JSON.parse(modal.getAttribute('data-bucket-map') || '{}');
        Object.keys(raw).forEach(function (pc) { bucketMap[pc] = raw[pc]; });
      } catch (e) { bucketMap = {}; }
    }
    var activeBucket = null;
    var bucketHandles = {};
    if (multiBucket && modal) {
      try {
        var rawH = JSON.parse(modal.getAttribute('data-bucket-handles') || '{}');
        Object.keys(rawH).forEach(function (pc) { bucketHandles[pc] = rawH[pc]; });
      } catch (e2) { bucketHandles = {}; }
    }
    if (pickerFilters) {
      pickerFilters.querySelectorAll('.bundle-deal-picker-filter').forEach(function (b) {
        catTitleMap[b.getAttribute('data-filter-collection')] = b.getAttribute('data-cat-title') || '';
      });
    }

    function showError(el, message) { if (!el) return; el.textContent = message; el.hidden = false; }
    function clearError(el) { if (!el) return; el.hidden = true; el.textContent = ''; }
    function itemMatchesSearch(item) { if (!searchTerm) return true; var title = (item.getAttribute('data-product-title') || '').toLowerCase(); var cat = (item.getAttribute('data-cat-title') || '').toLowerCase(); return title.indexOf(searchTerm) !== -1 || (cat && cat.indexOf(searchTerm) !== -1); }
    function allItems() { return pickerGrid ? pickerGrid.querySelectorAll('.bundle-deal-picker-item') : []; }

    function thumbUrl(url) {
      if (!url) return '';
      if (url.indexOf('width=') !== -1) return url;
      return url.split('?')[0] + '?width=140&height=140&crop=center';
    }

    function pickerUrl(handle, pageNum) {
      return '/collections/' + encodeURIComponent(handle) + '?view=picker' + (pageNum > 1 ? '&page=' + pageNum : '');
    }

    /* Geen Accept-header meesturen: Shopify antwoordt met 404 op een
       ?view=<suffix> verzoek zodra die op text/plain staat. */
    function fetchCategory(handle) {
      if (catLoaded[handle]) return Promise.resolve(catCache[handle]);
      var out = [];
      function page(p) {
        return fetch(pickerUrl(handle, p))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (text) {
            var data = null;
            try { data = JSON.parse(String(text).trim()); } catch (e) { data = null; }
            if (!data) return out;
            (data.products || []).forEach(function (pr) {
              var variants = pr.v || [];
              var image = pr.i || '';
              if (multiBucket) {
                variants.forEach(function (v) {
                  var cents = v[1];
                  if (!v[2]) return;
                  if (!bucketMap[cents]) return;
                  out.push({ id: v[0], title: pr.t, image: image, cat: handle, catTitle: catTitleMap[handle] || '', priceCents: cents });
                });
                return;
              }
              var match = null;
              variants.forEach(function (v) { if (match) return; if (v[1] === basePriceCents && v[2]) match = v; });
              if (!match) return;
              out.push({ id: match[0], title: pr.t, image: image, cat: handle, catTitle: catTitleMap[handle] || '' });
            });
            if (data.next) return page(p + 1);
            return out;
          })
          .catch(function () { return out; });
      }
      return page(1).then(function (list) { catCache[handle] = list; catLoaded[handle] = true; return list; });
    }

    /* Let op: geen content-visibility of contain op de tegel zetten.
       Beide brengen paint-containment mee, en de aantalbadge staat
       bewust op top:-6px / right:-6px — die wordt dan weggeknipt en
       de bezoeker ziet niet meer hoe vaak hij iets gekozen heeft. */
    function buildTile(item, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-deal-picker-item';
      btn.setAttribute('data-cat', activeCat);
      btn.setAttribute('data-variant-id', item.id);
      btn.setAttribute('data-product-title', item.title);
      if (item.catTitle) btn.setAttribute('data-cat-title', item.catTitle);
      if (multiBucket && item.priceCents) btn.setAttribute('data-price-cents', item.priceCents);
      if (item.image) {
        var im = document.createElement('img');
        im.src = thumbUrl(item.image);
        im.alt = item.title;
        im.decoding = 'async';
        im.width = 60; im.height = 60;
        if (index < 12) {
          im.loading = 'eager';
          try { im.fetchPriority = index < 6 ? 'high' : 'auto'; } catch (e) {}
        } else {
          im.loading = 'lazy';
        }
        btn.appendChild(im);
      } else {
        var ph = document.createElement('span');
        ph.className = 'bundle-deal-picker-item__noimg';
        ph.setAttribute('aria-hidden', 'true');
        ph.innerHTML = '&#127873;';
        btn.appendChild(ph);
      }
      var tt = document.createElement('span');
      tt.className = 'bundle-deal-picker-item__title';
      tt.textContent = item.title;
      btn.appendChild(tt);
      if (multiBucket && item.priceCents) {
        var pricePill = document.createElement('span');
        pricePill.className = 'bundle-deal-picker-item__cat';
        pricePill.style.display = 'block';
        pricePill.textContent = '\u20AC' + (item.priceCents / 100).toFixed(2).replace('.', ',');
        btn.appendChild(pricePill);
      } else if (item.catTitle) {
        var catPill = document.createElement('span');
        catPill.className = 'bundle-deal-picker-item__cat';
        catPill.textContent = item.catTitle;
        btn.appendChild(catPill);
      }
      var cnt = document.createElement('span');
      cnt.className = 'bundle-deal-picker-item__count';
      cnt.setAttribute('data-item-count', '');
      cnt.hidden = true; cnt.textContent = '0';
      btn.appendChild(cnt);
      return btn;
    }

    /* Grid in porties opbouwen: op de goedkopere prijspunten matcht bijna
       de hele catalogus, en 250+ tegels in één keer neerzetten maakt het
       openen merkbaar traag. */
    var CHUNK_SIZE = 60;
    var pendingItems = [];
    var renderedCount = 0;
    var sentinel = null;
    var sentinelObserver = null;

    function teardownSentinel() {
      if (sentinelObserver) { sentinelObserver.disconnect(); sentinelObserver = null; }
      if (sentinel && sentinel.parentNode) { sentinel.parentNode.removeChild(sentinel); }
      sentinel = null;
    }

    function appendChunk() {
      if (!pickerGrid || !pendingItems.length) { teardownSentinel(); return; }
      var batch = pendingItems.splice(0, CHUNK_SIZE);
      var frag = document.createDocumentFragment();
      batch.forEach(function (item) {
        frag.appendChild(buildTile(item, renderedCount));
        renderedCount++;
      });
      if (sentinel && sentinel.parentNode === pickerGrid) {
        pickerGrid.insertBefore(frag, sentinel);
      } else {
        pickerGrid.appendChild(frag);
      }
      if (!pendingItems.length) { teardownSentinel(); }
      updatePickerState();
    }

    function renderList(list) {
      if (!pickerGrid) return;
      teardownSentinel();
      pickerGrid.innerHTML = '';
      pendingItems = list.slice();
      renderedCount = 0;

      if (pendingItems.length > CHUNK_SIZE && 'IntersectionObserver' in window) {
        sentinel = document.createElement('span');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.gridColumn = '1 / -1';
        sentinel.style.height = '1px';
        pickerGrid.appendChild(sentinel);
        sentinelObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { appendChunk(); }
        }, { rootMargin: '600px' });
        sentinelObserver.observe(sentinel);
      }

      appendChunk();
    }

    function renderCat(handle) {
      if (!pickerGrid) return;
      pickerGrid.classList.remove('is-searching');
      var list = catCache[handle] || [];
      if (multiBucket) {
        list = list.slice().sort(function (a, b) {
          var pa = a.priceCents || 0, pb = b.priceCents || 0;
          if (pb !== pa) return pb - pa;
          return (a.title || '').localeCompare(b.title || '');
        });
      }
      renderList(list);
    }

    function renderSearchResults() {
      if (!pickerGrid) return;
      pickerGrid.classList.add('is-searching');
      var seen = {};
      var matches = [];
      Object.keys(catCache).forEach(function (handle) {
        if (!catLoaded[handle]) return;
        var catTitleLower = (catTitleMap[handle] || '').toLowerCase();
        var catMatches = searchTerm && catTitleLower.indexOf(searchTerm) !== -1;
        (catCache[handle] || []).forEach(function (item) {
          if (seen[item.id]) return;
          var title = (item.title || '').toLowerCase();
          if (searchTerm && !catMatches && title.indexOf(searchTerm) === -1) return;
          seen[item.id] = true;
          matches.push(item);
        });
      });
      renderList(matches);
    }

    /* Verbergt tabs zonder producten op dit prijspunt. Wisselt NOOIT zelf
       van categorie zodra de bezoeker er zelf een heeft aangeklikt. */
    function probeEmptyTabs() {
      if (probedTabs || !pickerFilters) return;
      probedTabs = true;
      var btns = pickerFilters.querySelectorAll('.bundle-deal-picker-filter');
      btns.forEach(function (b) {
        var handle = b.getAttribute('data-filter-collection');
        fetchCategory(handle).then(function (list) {
          if (list.length > 0) { b.hidden = false; return; }
          b.hidden = true;
          if (userPickedTab) return;
          if (handle !== activeCat) return;
          var first = pickerFilters.querySelector('.bundle-deal-picker-filter:not([hidden])');
          if (first) {
            first.classList.add('is-active');
            b.classList.remove('is-active');
            switchCat(first.getAttribute('data-filter-collection'));
          }
        });
      });
    }

    function switchCat(handle) {
      activeCat = handle;
      if (pickerLoading) pickerLoading.hidden = false;
      if (pickerGrid) { teardownSentinel(); pickerGrid.innerHTML = ''; }
      fetchCategory(handle).then(function () {
        if (activeCat !== handle) return;
        if (pickerLoading) pickerLoading.hidden = true;
        renderCat(handle);
      });
    }

    function euroCents(c) { return '\u20AC' + (c / 100).toFixed(2).replace('.', ','); }
    function repriceMultiTiers() {
      if (!multiBucket) return;
      tierButtons.forEach(function (btn) {
        if (btn.getAttribute('data-multi-tier') !== '1') return;
        var qty = parseInt(btn.getAttribute('data-tier-qty'), 10);
        var priceEl = btn.querySelector('[data-multi-price]');
        var strikeEl = btn.querySelector('[data-multi-strike]');
        var noteEl = btn.querySelector('[data-multi-note]');
        if (activeBucket && bucketMap[activeBucket] && bucketMap[activeBucket][qty] != null) {
          var tierCents = bucketMap[activeBucket][qty];
          var normalCents = activeBucket * qty;
          btn.setAttribute('data-tier-price', (tierCents / 100).toFixed(2));
          if (priceEl) priceEl.textContent = euroCents(tierCents);
          if (strikeEl) { strikeEl.textContent = euroCents(normalCents); strikeEl.hidden = false; }
          if (noteEl) noteEl.textContent = 'save ' + euroCents(normalCents - tierCents);
        } else {
          btn.removeAttribute('data-tier-price');
          if (priceEl) priceEl.textContent = '\u2014';
          if (strikeEl) { strikeEl.hidden = true; strikeEl.textContent = ''; }
          if (noteEl) noteEl.textContent = 'pick a keychain';
        }
      });
      var activeTierBtn = root.querySelector('.bundle-deal-tier--multi.is-active');
      if (activeTierBtn) currentTier.price = activeTierBtn.getAttribute('data-tier-price');
    }

    function updatePickerState() {
      if (pickerCount) pickerCount.textContent = selectedTotal;
      if (pickerNeeded) pickerNeeded.textContent = currentTier.qty;
      if (multiBucket && selectedTotal === 0) { activeBucket = null; repriceMultiTiers(); }
      var atLimit = selectedTotal >= currentTier.qty;
      var visibleCount = 0;
      allItems().forEach(function (item) {
        var variantId = item.getAttribute('data-variant-id');
        var count = selectedCounts[variantId] || 0;
        var badge = item.querySelector('[data-item-count]');
        if (badge) { badge.textContent = count; badge.hidden = count === 0; }
        item.classList.toggle('is-selected', count > 0);
        var bucketLocked = false;
        if (multiBucket && activeBucket) {
          var pc = parseInt(item.getAttribute('data-price-cents'), 10);
          bucketLocked = pc !== activeBucket;
        }
        item.classList.toggle('is-bucket-locked', bucketLocked);
        item.classList.toggle('is-disabled', bucketLocked || (atLimit && count === 0));
        var visible = itemMatchesSearch(item);
        item.hidden = !visible;
        if (visible) visibleCount++;
      });
      if (pickerEmpty) pickerEmpty.hidden = !(visibleCount === 0 && pendingItems.length === 0);
      ctaButton.disabled = selectedTotal !== currentTier.qty;
      renderSelectionStrip();
    }

    function renderSelectionStrip() {
      if (!selectionStrip) return;
      var ids = Object.keys(selectedCounts);
      if (ids.length === 0) { selectionStrip.hidden = true; selectionStrip.innerHTML = ''; return; }
      selectionStrip.hidden = false;
      selectionStrip.innerHTML = '';
      ids.forEach(function (variantId) {
        var count = selectedCounts[variantId];
        if (!count) return;
        var meta = selectedMeta[variantId] || { title: '', image: '' };
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bundle-deal-selchip';
        chip.setAttribute('data-selchip-id', variantId);
        chip.title = meta.title;
        if (meta.image) {
          var im = document.createElement('img');
          im.src = meta.image.indexOf('?') === -1 ? (meta.image + '?width=96') : meta.image;
          im.alt = meta.title;
          chip.appendChild(im);
        } else {
          var ph = document.createElement('span');
          ph.className = 'bundle-deal-selchip__noimg';
          ph.setAttribute('aria-hidden', 'true');
          ph.innerHTML = '&#127873;';
          chip.appendChild(ph);
        }
        if (count > 1) {
          var bd = document.createElement('span');
          bd.className = 'bundle-deal-selchip__badge';
          bd.textContent = '\u00d7' + count;
          chip.appendChild(bd);
        }
        var x = document.createElement('span');
        x.className = 'bundle-deal-selchip__x';
        x.setAttribute('aria-hidden', 'true');
        x.innerHTML = '&times;';
        chip.appendChild(x);
        selectionStrip.appendChild(chip);
      });
    }
    function resetSelection() { selectedCounts = {}; selectedMeta = {}; selectedTotal = 0; }
    function preselectCurrentProduct() {
      if (!isProductContext || !currentVariantId) return;
      var vId = String(currentVariantId);
      selectedCounts[vId] = 1;
      selectedTotal = 1;
      selectedMeta[vId] = { title: root.getAttribute('data-current-title') || '', image: root.getAttribute('data-current-image') || '' };
    }
    function moveActiveTabFirst() {
      if (!pickerFilters || !activeCat) return;
      var activeBtn = pickerFilters.querySelector('.bundle-deal-picker-filter[data-filter-collection="' + activeCat + '"]');
      if (activeBtn && activeBtn.parentNode) { activeBtn.parentNode.insertBefore(activeBtn, activeBtn.parentNode.firstChild); }
    }
    function openModal() { if (!modal) return; if (modal.parentNode !== document.body) document.body.appendChild(modal); modal.hidden = false; document.body.style.overflow = 'hidden'; userPickedTab = false; if (pickerSearch) { pickerSearch.value = ''; searchTerm = ''; } var homeCat = modal.getAttribute('data-current-cat') || ''; if (homeCat) { activeCat = homeCat; if (pickerFilters) { pickerFilters.querySelectorAll('.bundle-deal-picker-filter').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-filter-collection') === homeCat); }); } } moveActiveTabFirst(); probeEmptyTabs(); switchCat(activeCat); if (pickerSearch) pickerSearch.focus(); }
    function closeModal() { if (!modal) return; modal.hidden = true; document.body.style.overflow = ''; }
    if (modalOverlay) modalOverlay.addEventListener('click', closeModal);
    if (modalClose) modalClose.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });
    if (pickerFilters) { pickerFilters.addEventListener('click', function (event) { var btn = event.target.closest('.bundle-deal-picker-filter'); if (!btn) return; userPickedTab = true; pickerFilters.querySelectorAll('.bundle-deal-picker-filter').forEach(function (b) { b.classList.remove('is-active'); }); btn.classList.add('is-active'); if (pickerSearch) { pickerSearch.value = ''; searchTerm = ''; } switchCat(btn.getAttribute('data-filter-collection')); }); }
    if (pickerSearch) { pickerSearch.addEventListener('input', function () { searchTerm = pickerSearch.value.trim().toLowerCase(); if (searchTerm) { renderSearchResults(); } else { renderCat(activeCat); } }); }
    function formatEuro(value) { return '\u20AC' + value.toFixed(2).replace('.', ','); }
    function renderSingle() { if (singleCountEl) singleCountEl.textContent = singleQty; if (singleLabel) singleLabel.textContent = singleQty === 1 ? '1 piece' : singleQty + ' pieces'; if (singlePriceEl) singlePriceEl.textContent = formatEuro(singleBasePrice * singleQty); }
    function selectTier(button) {
      tierButtons.forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');
      currentTier.qty = parseInt(button.getAttribute('data-tier-qty'), 10);
      currentTier.price = button.getAttribute('data-tier-price');
      resetSelection();
      clearError(errorEl);
      clearError(errorSingleEl);
      var setVariants = button.getAttribute('data-set-variants');
      if (button.getAttribute('data-tier-set') === '1' && setVariants) {
        if (button.getAttribute('data-adding') === '1') return;
        button.setAttribute('data-adding', '1');
        var ids = setVariants.split(',').filter(function (x) { return x; });
        var setItems = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
        addItems(applyBundleProps(setItems, currentTier.qty), errorEl, null).finally(function () {
          setTimeout(function () { button.removeAttribute('data-adding'); }, 800);
        });
        return;
      }
      var isSingle = currentTier.qty === 1;
      if (isSingle && isProductContext) {
        if (singleStepper) singleStepper.hidden = false;
        if (addSingleBtn) { addSingleBtn.hidden = false; addSingleBtn.disabled = false; }
      } else {
        singleQty = 1;
        renderSingle();
        if (singleStepper) singleStepper.hidden = true;
        if (addSingleBtn) addSingleBtn.hidden = true;
        preselectCurrentProduct();
        openModal();
      }
    }
    tierButtons.forEach(function (button) { button.addEventListener('click', function () { selectTier(button); }); });
    if (pickerGrid) {
      pickerGrid.addEventListener('click', function (event) {
        var item = event.target.closest('.bundle-deal-picker-item');
        if (!item || item.classList.contains('is-disabled')) return;
        var variantId = item.getAttribute('data-variant-id');
        var count = selectedCounts[variantId] || 0;
        if (selectedTotal < currentTier.qty) {
          if (multiBucket && !activeBucket) {
            var pc = parseInt(item.getAttribute('data-price-cents'), 10);
            if (pc && bucketMap[pc]) { activeBucket = pc; repriceMultiTiers(); }
          }
          selectedCounts[variantId] = count + 1; selectedTotal++;
          var imgEl = item.querySelector('img');
          selectedMeta[variantId] = { title: item.getAttribute('data-product-title') || '', image: imgEl ? imgEl.getAttribute('src') : '' };
        }
        else if (count > 0) { selectedCounts[variantId] = count - 1; selectedTotal--; if (selectedCounts[variantId] === 0) delete selectedCounts[variantId]; }
        updatePickerState();
      });
      pickerGrid.addEventListener('contextmenu', function (event) {
        var item = event.target.closest('.bundle-deal-picker-item');
        if (!item) return;
        var variantId = item.getAttribute('data-variant-id');
        var count = selectedCounts[variantId] || 0;
        if (count > 0) { event.preventDefault(); selectedCounts[variantId] = count - 1; selectedTotal--; if (selectedCounts[variantId] === 0) delete selectedCounts[variantId]; updatePickerState(); }
      });
    }
    if (selectionStrip) {
      selectionStrip.addEventListener('click', function (event) {
        var chip = event.target.closest('.bundle-deal-selchip');
        if (!chip) return;
        var variantId = chip.getAttribute('data-selchip-id');
        var count = selectedCounts[variantId] || 0;
        if (count > 0) { selectedCounts[variantId] = count - 1; selectedTotal--; if (selectedCounts[variantId] === 0) delete selectedCounts[variantId]; updatePickerState(); }
      });
    }

    function refreshCartDrawer() {
      if (window.DWLCart && typeof window.DWLCart.refreshCartUI === 'function') {
        return window.DWLCart.refreshCartUI(true);
      }
      var fallbackId = (window.DWLCart && typeof window.DWLCart.drawerSectionId === 'function') ? window.DWLCart.drawerSectionId() : null;
      if (!fallbackId) { window.location.href = '/cart'; return Promise.resolve(); }
      return fetch('/?sections=' + fallbackId).then(function (r) { return r.json(); }).then(function (sections) {
        var html = sections[fallbackId];
        if (!html) { window.location.href = '/cart'; return; }
        var newDoc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = newDoc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer && oldDrawer.parentNode) { oldDrawer.parentNode.replaceChild(newDrawer, oldDrawer); if (typeof newDrawer.open === 'function') newDrawer.open(); }
        else { window.location.href = '/cart'; }
      });
    }
    function makeBundleId() { return bundleHandle + '-' + Date.now() + '-' + Math.floor(Math.random() * 1000); }
    function applyBundleProps(items, tierQty) {
      var handle = bundleHandle;
      if (multiBucket && activeBucket && bucketHandles[activeBucket]) { handle = bucketHandles[activeBucket]; }
      if (!handle) return items;
      var bid = makeBundleId();
      return items.map(function (it) {
        var props = it.properties || {};
        props._bundle = handle;
        props._bundle_id = bid;
        props._bundle_tier = String(tierQty);
        it.properties = props;
        return it;
      });
    }
    function addItems(items, onErrorEl, onDoneBtn, onAdded) {
      var addedQty = 0;
      items.forEach(function (it) { addedQty += (it.quantity || 1); });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (response) { if (!response.ok) { return response.json().then(function (data) { throw new Error(data.description || 'Could not add to cart.'); }); } return response.json(); })
        .then(function (data) {
          try { document.dispatchEvent(new CustomEvent('dwl:bundle-added', { detail: { qty: addedQty, sourceEl: onDoneBtn || ctaButton } })); } catch (e) {}
          if (onAdded) onAdded();
          refreshCartDrawer();
        })
        .catch(function (error) { showError(onErrorEl, error.message); })
        .finally(function () { if (onDoneBtn) onDoneBtn.disabled = false; });
    }
    ctaButton.addEventListener('click', function () {
      clearError(errorEl);
      ctaButton.disabled = true;
      var items = Object.keys(selectedCounts).map(function (id) { return { id: parseInt(id, 10), quantity: selectedCounts[id] }; });
      addItems(applyBundleProps(items, currentTier.qty), errorEl, ctaButton, function () { closeModal(); });
    });
    if (singleMinus) singleMinus.addEventListener('click', function (e) { e.stopPropagation(); singleQty = Math.max(1, singleQty - 1); renderSingle(); });
    if (singlePlus) singlePlus.addEventListener('click', function (e) { e.stopPropagation(); singleQty = Math.min(999, singleQty + 1); renderSingle(); });
    if (addSingleBtn) { addSingleBtn.addEventListener('click', function () { clearError(errorSingleEl); addSingleBtn.disabled = true; var vId = parseInt(currentVariantId, 10); addItems([{ id: vId, quantity: singleQty }], errorSingleEl, addSingleBtn); }); }

    if (isProductContext && activeCat) {
      var doPrefetch = function () { fetchCategory(activeCat); };
      if ('requestIdleCallback' in window) { requestIdleCallback(doPrefetch, { timeout: 2000 }); }
      else { setTimeout(doPrefetch, 1200); }
    }
  }
  function bootBundleDealCards() { document.querySelectorAll('.bundle-deal-card').forEach(function (el) { if (el.getAttribute('data-bundle-init') === '1') return; el.setAttribute('data-bundle-init', '1'); initBundleDealCard(el); }); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bootBundleDealCards); } else { bootBundleDealCards(); }
})();
